import React from 'react'
import { LinkOutlined } from '@ant-design/icons'

import CopyIconButton from './CopyIconButton'
import { rowDeepLinkUrl, type ReviewQueueOpenTarget } from './url-state'

/**
 * Copy a link that opens THIS row — the producer for the `rqOpen` one-shot
 * (./url-state), so an operator can hand a colleague one item rather than "the
 * Discrepancies tab, search the benefit, third one down".
 *
 * It has to exist rather than being left to hand-assembly: a discrepancy is
 * identified by `benefitId:periodStartDate:issueType` and its row renders none
 * of those three — the period shows as `MMM YYYY` and the benefit id not at
 * all. On the transaction side the neighbouring "Copy token" button copies the
 * card rail's token, which is not a link to anything.
 *
 * Not gated on write access: a read-only operator can still be the one who
 * spots the item and passes it on.
 */
const CopyRowLinkButton: React.FC<{ target: ReviewQueueOpenTarget }> = ({
  target,
}) => (
  <CopyIconButton
    value={rowDeepLinkUrl(target)}
    label="Copy link to this row"
    tooltip="Copy link to this row"
    icon={<LinkOutlined />}
    successMessage="Link copied"
  />
)

export default CopyRowLinkButton
